import Message from './Message';

export default (function (w, d) {
    'use strict';

    function ProductCommentPopup() {
        this.popup = d.querySelector('.comment-popup').parentElement;
        this.openButtons = d.querySelectorAll('.open-product-comment-popup');
        this.closeButton = this.popup.querySelector('.close');
        this.form = this.popup.querySelector('.comment-form');
        this.formSubmitButton = this.form.querySelector('.submit-comment');
        this.init();
    }

    ProductCommentPopup.prototype.init = function () {
        this.initOpenCloseButtons();
        this.initFormSubmitBtn();
    }

    ProductCommentPopup.prototype.initOpenCloseButtons = function () {
        if (this.openButtons !== undefined) {
            this.openButtons.forEach(button => {
                button.addEventListener('click', () => {
                    this.popup.classList.toggle('hidden');
                });
            });

            this.closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.popup.classList.toggle('hidden');
            });
        }
    }

    ProductCommentPopup.prototype.initFormSubmitBtn = function () {
        this.formSubmitButton.addEventListener('click', (e) => {
            e.preventDefault();

            const formData = $(this.form).serialize();
            const action = this.form.action;

            $.ajax({
                url: action,
                method: 'POST',
                data: formData,
                success: function (response) {
                    if (response.status === 'error') {
                        new Message(response.message, 'error');

                        return;
                    }

                    new Message(response.message, 'success')

                    setTimeout(() => {
                        w.location.reload();
                    }, 1000);
                },
            });
        });
    }

    return ProductCommentPopup;
}(window, document));

